import * as React from 'react';
import { useEffect } from 'react';
import MUIDataTable, { Responsive } from 'mui-datatables';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CustomPaginator from 'src/components/common/CustomPaginator';
import CloseIcon from '../../../assets/close';
import Modal from 'src/components/common/Modal';
import creditDollar from '../../../assets/creditDollar';
import manualEdit from '../../../assets/images/manual-edit.png';
import './SelectCredit.scss';
import invoiceServiceInstance from 'src/services/invoice/InvoiceService';
import InvoiceModel from 'src/model/invoice.model';
import theme from '../../../themes/theme';
import SearchIcon from 'src/assets/searchIcon';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import i18n from 'src/translation/i18n';

function SelectCreditTable(props: any) {
  const [responsive, setResponsive] = React.useState('vertical');
  const [tableBodyHeight, setTableBodyHeight] = React.useState('400px');
  const [tableBodyMaxHeight, setTableBodyMaxHeight] = React.useState('');
  const [transitionTime, setTransitionTime] = React.useState(300);
  const [rowscount, setRowscount] = React.useState(null);
  const [pagenumber, setPagenumber] = React.useState(0);
  const [pagesize, setPageSize] = React.useState(0);
  const [shortpaypopup, setShortpaypopup] = React.useState(false);
  const [amount, setAmount] = React.useState<number>();
  const [reason, setReason] = React.useState('');
  const [selectedData, setSelectedData] = React.useState([]);
  const [shortpaydata, setShortpaydata] = React.useState([]);
  const [selectedshortpayindex, setSelectedshortpayindex] = React.useState(
    null
  );
  const [selectedpaydata, setSelectedpaydata] = React.useState([]);
  const [tableChange, setTableChange] = React.useState(false);
  const [selectedinvoiceData, setSelectedinvoiceData] = React.useState([]);
  const [validationMessage, updateValidationMsg] = React.useState(null);
  const [valError, setValError] = React.useState(false);
  const [reasonIndex, setReasonIndex] = React.useState([]);
  const [searchInvoice, setSearchInvoice] = React.useState('');
  const [sortOption, setSortOption] = React.useState({
    name: 'invoiceDate',
    direction: 'asc'
  });
  React.useEffect(() => {
    const isSame =
      JSON.stringify(selectedinvoiceData) ===
      JSON.stringify(props.selectedinvoiceData);
    if (!isSame && !tableChange) {
      setSelectedinvoiceData(props.selectedinvoiceData);
    }
    setTimeout(() => {
      props.removeViewColumnBtn(false);
    }, 50);
  }, [props.selectedinvoiceData]);

  const getSortedInvoiceList = (a: any, b: any) => {
    if (a.invoiceDate < b.invoiceDate) {
      return -1;
    }
    if (a.invoiceDate > b.invoiceDate) {
      return 1;
    }
    return 0;
  };

  React.useEffect(() => {
    if (!props.continue) {
      const invoiceDataVal = props.selectedinvoiceData.sort(
        getSortedInvoiceList
      );
      const rowCountIndex: any[] = [];
      selectedData.forEach(val => {
        const index = invoiceDataVal.findIndex(
          (ele: any) => ele.idx === val.idx
        );
        if (index > -1) {
          rowCountIndex.push(index);
          invoiceDataVal[index].paymentAmount = val.paymentAmount;
          invoiceDataVal[index].remainingAmount = val.remainingAmount;
        }
      });
      const isSame =
        JSON.stringify(selectedinvoiceData) ===
        JSON.stringify(props.selectedinvoiceData);
      if (!isSame && !tableChange) {
        setSelectedinvoiceData(invoiceDataVal);
      }
      setRowscount(rowCountIndex);
    }
  }, [props.selectedinvoiceData]);

  React.useEffect(() => {
    setPagenumber(0);
  }, [searchInvoice, pagesize]);

  React.useEffect(() => {
    const newSelectedValues: any = [];
    selectedinvoiceData.forEach((ele: any) => {
      newSelectedValues.push(ele.invoiceNumber);
    });
    if (props.continue) {
      setSelectedData(selectedinvoiceData);
      props.setListOfInvoices(newSelectedValues);
    }
  }, [selectedinvoiceData]);

  React.useEffect(() => {
    props.isupdated(
      selectedshortpayindex,
      amount,
      selectedinvoiceData,
      selectedData
    );
  }, [selectedData]);

  React.useEffect(() => {
    if (!props.showCreditTable) {
      setSelectedData([]);
    }
  }, [props.showCreditTable]);

  const columns = [
    {
      label: `${i18n.t('invoices.invoiceNum')}`,
      name: 'invoiceNumber',
      options: {
        filter: false,
        customBodyRender: (value: any, tablemeta: any) => {
          return (
            <label>
              {value}
              <img
                className="icon-position"
                title="Credit Invoices"
                src={creditDollar}
              />
            </label>
          );
        }
      }
    },
    { label: `${i18n.t('invoices.invoiceDate')}`, name: 'invoiceDate' },
    {
      label: `${i18n.t('invoices.availCredit')}`,
      name: 'totalAmount',
      options: {
        filter: false,
        customBodyRender: (value: any, tablemeta: any) => {
          // return <label>$ {parseFloat(value).toFixed(2)}</label>;
          return <label>{currencyFormatter(value)}</label>;
        }
      }
    },
    // { label: 'Payment.Amt', name: 'paymentAmount' },
    {
      label: `${i18n.t('invoices.paymentAmt')}`,
      name: 'paymentAmount',
      options: {
        filter: false,
        empty: true,
        sort: false,
        customBodyRender: (value: any, tablemeta: any) => {
          return (
            // <span
            //   className="remainig-amount-link"
            //   onClick={() => shortPay(tablemeta, value)}
            // >
            <label>
              {currencyFormatter(value)}
              {props.onCreditSummary || props.continue ? (
                <img
                  className="icon-position short-pay-edit"
                  title="Short pay"
                  src={manualEdit}
                  onClick={() => shortPay(tablemeta, value)}
                />
              ) : (
                ''
              )}
            </label>
            // </span>
          );
        }
      }
    },
    {
      label: `${i18n.t('invoices.payRem')}`,
      name: 'remainingAmount',
      options: {
        sort: false,
        customBodyRender: (value: any, tablemeta: any) => {
          // return <label>$ {parseFloat(value).toFixed(2)}</label>;
          return <label>{currencyFormatter(value)}</label>;
        }
      }
    },
    {
      label: 'transactionId',
      name: 'transactionId',
      options: { display: false }
    }
  ];

  const shortPay = (tablemeta: any, value: any) => {
    const isChecked =
      selectedData.filter(x => x.invoiceNumber === tablemeta?.rowData[0])
        .length > 0;
    if (isChecked) {
      let creditdata: number[] = [];
      if (reasonIndex && reasonIndex.length > 0) {
        const indexVal = reasonIndex.findIndex(
          (val: any) => val.invNum === tablemeta?.rowData[5]
        );
        if (indexVal > -1) {
          setReason(reasonIndex[indexVal].message);
          setAmount(Math.abs(value));
        } else {
          setReason('');
          setAmount(null);
        }
      }
      setShortpaypopup(true);
      // props.setSelectedCreditInvoices(selectedData);
      creditdata = tablemeta.rowData;
      setSelectedshortpayindex(tablemeta);

      setShortpaydata(creditdata);
    } else {
      props.handleShortPayError();
    }
  };
  const getTargetpaymentsData = () => {
    const appliedCreditInvoices: any[] = [];

    selectedData.forEach((num: any) => {
      appliedCreditInvoices.push({
        orderNumber: num.orderNumber,
        paymentAmount: num.remainingAmount,
        reasonRemainingBalance: reason,
        transactionId: num.transactionId
      });
    });
    props.selectedInvoices.forEach((num: any) => {
      appliedCreditInvoices.push({
        orderNumber: num.orderNumber,
        paymentAmount: num.remainingAmount,
        reasonRemainingBalance: reason,
        transactionId: num.transactionId
      });
    });
    return appliedCreditInvoices;
  };
  const savebtn = () => {
    if (
      amount != null &&
      amount !== 0 &&
      amount !== undefined &&
      !isNaN(amount) &&
      amount * -1 === shortpaydata[2]
    ) {
      setReason('');
      updateValidationMsg('');
      shortPayValueSet();
    } else if (
      reason === '' ||
      reason == null ||
      amount == null ||
      amount === 0 ||
      amount === undefined ||
      isNaN(amount)
    ) {
      updateValidationMsg(i18n.t('invoices.message5'));
    } else if (amount * -1 < shortpaydata[2]) {
      updateValidationMsg(i18n.t('invoices.message6'));
    } else {
      shortPayValueSet();
    }
  };
  const shortPayValueSet = () => {
    updateValidationMsg('');
    setTableChange(true);
    // set table value
    const modifiedTableData = selectedinvoiceData.map(
      (item: any, index: any) => {
        if (selectedshortpayindex.rowData[5] === item.transactionId) {
          return {
            ...item,
            paymentAmount: (-1 * (amount / 1)).toFixed(2),
            remainingAmount: (
              -1 *
              (-1 * (item.totalAmount / 1) - amount / 1)
            ).toFixed(2),
            reasonText: reason
          };
        }
        return item;
      }
    );
    const invoiceRowData = selectedshortpayindex.rowData[5];
    const findIndexVal = reasonIndex.findIndex(
      (val: any) => val.invNum === invoiceRowData
    );
    if (findIndexVal > -1) {
      const newReasonIndex = [...reasonIndex];
      newReasonIndex[findIndexVal].message = reason;
      setReasonIndex(newReasonIndex);
    } else {
      const objVal: any = {};
      objVal.invNum = invoiceRowData;
      objVal.message = reason;
      reasonIndex.push(objVal);
      setReasonIndex(reasonIndex);
    }
    setSelectedinvoiceData(modifiedTableData);
    if (selectedData && selectedData.length > 0) {
      const seletObjData = selectedData.filter(
        a => a.transactionId === selectedshortpayindex.rowData[5]
      )[0];
      if (selectedData && selectedData.length > 0) {
        seletObjData.paymentAmount = (-1 * (amount / 1)).toFixed(2);
        seletObjData.remainingAmount = (
          -1 *
          (-1 * (seletObjData.totalAmount / 1) - amount / 1)
        ).toFixed(2);
        seletObjData['reasonText'] = reason;
      }
    }

    const paymentdata = getTargetpaymentsData();

    props.isupdated(
      selectedshortpayindex,
      amount,
      selectedinvoiceData,
      selectedData
    );
    setShortpaypopup(false);
    // setReason('');
    // setAmount(null);
  };
  const changeSetAmount = (amt: number) => {
    const chkAmt = amt < 0 ? amt : -1 * (amt / 1);
    if (chkAmt === shortpaydata[2]) {
      setReason('');
      updateValidationMsg('');
    }
    setAmount(amt < 0 ? -1 * (amt / 1) : amt);
  };
  const clickclose = () => {
    setShortpaypopup(false);
  };

  const { getselectCredit } = props;
  const { totalCreditmanual } = props;
  const { totalDebitmanual } = props;

  // const { selectedinvoiceData } = props;
  const { selectedCreditInvoicesData } = props;
  const { selectedInvoices } = props;
  const handlePagination = (newpage: number) => {
    const { datesFilter, statusFilter, sortFilter, pagination } = props;
    const filters: any = {};
    if (newpage - 1 !== pagenumber) {
      setPagenumber(newpage - 1);
      const newPagination = {
        page: newpage - 1,
        size: pagesize
      };
      setTableChange(false);
      getselectCredit(filters, newPagination);
    }
  };
  const handlePageSizeChange = (pageSizeVal: any) => {
    const { datesFilter, statusFilter, sortFilter, pagination } = props;
    const filters: any = {};
    const newPagination = {
      page: 0,
      size: pageSizeVal
    };
    setPageSize(pageSizeVal);
    setTableChange(false);
    getselectCredit(filters, newPagination);
  };

  const handleInputChange = (event: any) => {
    const value = event.target.value;
    const filters: any = { invoiceNumber: value };
    const newPagination = {
      page: 0,
      size: 20
    };
    setSearchInvoice(value);
    setTableChange(false);
    if (value.length === 7) {
      getselectCredit(filters, newPagination);
    } else if (value.length === 0) {
      getselectCredit({}, newPagination);
    }
  };

  const creditTableClick = () => {
    setTimeout(() => {
      props.removeViewColumnBtn(true);
    }, 100);
  };

  const findDuplicates = (allselctValue: any) => {
    const obj = {};
    for (let i = 0, len = allselctValue.length; i < len; i++) {
      obj[allselctValue[i]['idx']] = allselctValue[i];
    }
    allselctValue = new Array();
    for (const key of Object.keys(obj)) {
      allselctValue.push(obj[key]);
    }
    return allselctValue;
  };

  const onRowSelectionChange = (
    currentRowsSelected: any,
    allRowsSelected: any,
    rowsSelectedpath: any
  ) => {
    if (currentRowsSelected.length === 0) {
      setSelectedData([]);
      setRowscount(null);
    } else {
      const selections: any[] = [];
      // setAmount(amount.push(id:rowsSelectedpath.invoiceNumber))
      props.isChecked(rowsSelectedpath, selectedinvoiceData, amount);

      setRowscount(rowsSelectedpath);

      rowsSelectedpath.map((index: any) => {
        const obj = {
          invoiceNumber: selectedinvoiceData[index].invoiceNumber,
          invoiceDate: selectedinvoiceData[index].invoiceDate,
          totalAmount: selectedinvoiceData[index].totalAmount,
          paymentAmount: selectedinvoiceData[index].paymentAmount,
          remainingAmount: selectedinvoiceData[index].remainingAmount,
          orderNumber: selectedinvoiceData[index].orderNumber,
          transactionId: selectedinvoiceData[index].transactionId,
          idx: selectedinvoiceData[index].idx
        };
        selections.push(obj);
      });
      if (currentRowsSelected && currentRowsSelected.length > 0) {
        const indexCheck = rowsSelectedpath.findIndex(
          (ele: any) => ele === currentRowsSelected[0].index
        );
        if (selectedData && selectedData.length > 0 && indexCheck === -1) {
          const currentInvoiceData =
            selectedinvoiceData[currentRowsSelected[0].index];
          const indexInv = selectedData.findIndex(
            el => el.idx === currentInvoiceData.idx
          );
          selectedData.splice(indexInv, 1);
        }
      }
      const selectVal = selectedData.concat(selections);
      const finalSelectedData = findDuplicates(selectVal);
      setSelectedData(finalSelectedData);
    }
  };

  const handleSearchCloseIcon = () => {
    const newPagination = {
      page: 0,
      size: 20
    };
    setSearchInvoice('');
    getselectCredit({}, newPagination);
  };

  const sortSelectedInvoiceData = (
    fVal: any,
    sVal: any,
    name: any,
    direction: any
  ) => {
    if (fVal[name] < sVal[name]) {
      return direction === 'asc' ? -1 : 1;
    }
    if (fVal[name] > sVal[name]) {
      return direction === 'asc' ? 1 : -1;
    }
    return 0;
  };
  const onColumnSortChange = (name: string, direction: string) => {
    setSortOption({ name, direction });
  };

  const options = {
    filter: false,
    search: false,
    download: false,
    pagination: false,
    disableToolbarSelect: true,
    print: false,
    selectableRows:
      props.onCreditSummary || props.continue ? (false as any) : (true as any),
    onRowSelectionChange,
    onColumnSortChange,
    sort: true,
    fixedHeader: false,
    responsive: 'standard' as Responsive,
    sortOrder: {
      name: sortOption.name,
      direction: sortOption.direction as any
    },
    rowsSelected: rowscount,
    draggableColumns: {
      enabled: true,
      transitionTime
    },

    customToolbar: () =>
      props.showCreditTable &&
      !props.onCreditSummary && (
        <div className="justify-space-bw-man">
          <div className="wrapper">
            <div className="search-container">
              <input
                type="text"
                placeholder={i18n.t('invoices.invoiceNum')}
                onChange={handleInputChange}
                value={searchInvoice}
              />
              <img className="search-icon" alt="search" src={SearchIcon} />
              {searchInvoice && searchInvoice.length > 0 && (
                <img
                  className="search-close-icon"
                  onClick={handleSearchCloseIcon}
                  alt="search"
                  src={CloseIcon}
                />
              )}
            </div>
          </div>
          <div className="rp-product-status--paginator">
            <CustomPaginator
              activePage={
                props.pagination.pageNumber
                  ? props.pagination.pageNumber + 1
                  : 1
              }
              totalPages={
                props.pagination.totalPages ? props.pagination.totalPages : 1
              }
              itemsPerPage={props.pagination.pageSize}
              onPageChanged={handlePagination}
              totalItems={
                props.pagination.totalPages * props.pagination.pageSize
              }
              showPageInfo={true}
              onPageSizeChange={handlePageSizeChange}
              showPageRangeChange={true}
              currentPageSize={props.pagination.pageSize}
            />
          </div>
        </div>
      )
  };

  const data = [];
  return (
    <div className="manual-credit-table">
      <React.Fragment>
        {props.isPending && (
          <div>
            <br />
            <div className="loader-container">
              <div className="loader" />
            </div>
          </div>
        )}
        {!props.isPending && (
          <div>
            {!props.continue ? (
              <div>
                {props.showCreditTable ? (
                  <div
                    className={`credit-table-section-${
                      props.onCreditSummary ? 'summary' : 'review'
                    }`}
                  >
                    <MuiThemeProvider theme={theme}>
                      <MUIDataTable
                        title={''}
                        data={
                          props.onCreditSummary
                            ? selectedData
                            : selectedinvoiceData
                        }
                        columns={columns}
                        options={options}
                      />
                    </MuiThemeProvider>
                  </div>
                ) : (
                  <div className="pay-select-credit">
                    {selectedinvoiceData.length > 0 ? (
                      <p onClick={creditTableClick}>
                        {i18n.t('invoices.payUsingCredits')}
                      </p>
                    ) : (
                      <span>{i18n.t('invoices.noCreditsAvailable')}</span>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <MuiThemeProvider theme={theme}>
                <MUIDataTable
                  title={''}
                  data={selectedinvoiceData}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
            )}
          </div>
        )}

        {shortpaypopup && (
          <div>
            <Modal handleCloseModal={() => console.log('Modal closed')}>
              <div className="short-pay">
                <div className="d-flex justify-space-bw">
                  <div className="modal-label">
                    {i18n.t('invoices.shortPay')}
                  </div>
                  <div className="close-icon" onClick={clickclose}>
                    <img src={CloseIcon} />
                  </div>
                </div>
                <div className="modal-content">
                  <table className="width-table">
                    <tr>
                      <td>
                        <div className="invoice-label">
                          {i18n.t('invoices.invoiceNo')}
                        </div>
                        <div>{shortpaydata[0]}</div>
                      </td>
                      <td>
                        <div className="invoice-label">
                          {i18n.t('invoices.invoiceDate')}
                        </div>
                        <div>{shortpaydata[1]}</div>
                      </td>
                      <td>
                        <div className="invoice-label">
                          {i18n.t('invoices.TotalAmount')}
                        </div>
                        <div>{currencyFormatter(shortpaydata[2])}</div>
                      </td>
                    </tr>
                  </table>
                  <div className="input-label">
                    {i18n.t('invoices.PaymentAmount')}
                  </div>

                  <div>
                    <input
                      type="number"
                      name="name"
                      value={amount}
                      onChange={e =>
                        changeSetAmount(parseFloat(e.target.value))
                      }
                    />
                  </div>

                  <div className="input-label">{i18n.t('invoices.reason')}</div>
                  <div className="reason">
                    <input
                      type="text"
                      name="name"
                      value={reason}
                      onChange={e => setReason(e.target.value)}
                    />
                  </div>
                  <div className="rp-input--message">{validationMessage}</div>
                </div>
                <div className="text-align-center">
                  <button className="cancel-btn" onClick={clickclose}>
                    {i18n.t('common.cancel')}
                  </button>
                  <button className="ok-btn" onClick={savebtn}>
                    {i18n.t('common.save')}
                  </button>
                </div>
              </div>
            </Modal>
          </div>
        )}
      </React.Fragment>
    </div>
  );
}
export default SelectCreditTable;
